import React from 'react';
import { Box, Container, Typography, Paper } from '@mui/material';

const PrivacyPolicyPage = () => {
  return (
    <Container maxWidth="md" sx={{ py: 4 }}>
      <Typography variant="h4" component="h1" gutterBottom fontWeight={700}>
        Privatumo politika
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
        Paskutinį kartą atnaujinta: {new Date().toLocaleDateString('lt-LT')}
      </Typography>

      <Paper sx={{ p: 3, mb: 2 }}>
        <Typography variant="h6" gutterBottom fontWeight={600}>
          Kas mes esame
        </Typography>
        <Typography variant="body1" paragraph>
          TenisoUžsiėmimai.lt – teniso treniruocių rezervacijų ir valdymo paslauga (svetainė ir mobili programėlė). Ši privatumo politika aprašo, kaip renkame, naudojame ir saugome jūsų duomenis.
        </Typography>
      </Paper>

      <Paper sx={{ p: 3, mb: 2 }}>
        <Typography variant="h6" gutterBottom fontWeight={600}>
          Kokius duomenis renkame
        </Typography>
        <Typography variant="body1" paragraph>
          • <strong>Paskyros duomenys:</strong> el. paštas, slaptažodis (saugomas užšifruotai), vardas ir pavardė, jei pateikiate.
        </Typography>
        <Typography variant="body1" paragraph>
          • <strong>Rezervacijų duomenys:</strong> pasirinktos datos, laikai, teniso aikštelės ir su jais susijusi informacija.
        </Typography>
        <Typography variant="body1" paragraph>
          • <strong>Kalendoriaus prieiga (mobilioje programėlėje):</strong> tik su jūsų leidimu – naudojame kalendoriui pridėti ar peržiūrėti rezervacijas.
        </Typography>
        <Typography variant="body1" paragraph>
          • <strong>Naršymo duomenys:</strong> svetainėje naudojame Google Analytics (anonimizuoti IP), kad suprastume, kaip naudojatės paslauga.
        </Typography>
      </Paper>

      <Paper sx={{ p: 3, mb: 2 }}>
        <Typography variant="h6" gutterBottom fontWeight={600}>
          Kaip naudojame duomenis
        </Typography>
        <Typography variant="body1" paragraph>
          Duomenis naudojame tik siekiant suteikti ir tobulinti paslaugą: paskyros valdymas, rezervacijų kūrimas ir rodymas, susisiekimas dėl užsiėmimų, svetainės ir programėlės veikimo užtikrinimas bei statistikos analizė.
        </Typography>
      </Paper>

      <Paper sx={{ p: 3, mb: 2 }}>
        <Typography variant="h6" gutterBottom fontWeight={600}>
          Duomenų saugojimas ir perdavimas
        </Typography>
        <Typography variant="body1" paragraph>
          Duomenys saugomi „Google“ (Firebase) ir „Google Analytics“ serveriuose. Perduodami tik per saugius (HTTPS) kanalus. Mes neperkame ir neperduodame jūsų asmens duomenų trečiosioms šalims prekybos tikslais.
        </Typography>
      </Paper>

      <Paper sx={{ p: 3, mb: 2 }}>
        <Typography variant="h6" gutterBottom fontWeight={600}>
          Saugojimo trukmė
        </Typography>
        <Typography variant="body1" paragraph>
          Paskyros ir rezervacijų duomenys saugomi, kol naudojatės paslauga arba kol ištrinsite paskyrą. Analitikos duomenys gali būti saugomi anonimiškai ilgesnį laikotarpį.
        </Typography>
      </Paper>

      <Paper sx={{ p: 3, mb: 2 }}>
        <Typography variant="h6" gutterBottom fontWeight={600}>
          Jūsų teisės
        </Typography>
        <Typography variant="body1" paragraph>
          Turite teisę peržiūrėti, taisyti ar ištrinti savo duomenis (pvz., per paskyros nustatymus arba kreipdamiesi į mus). Paskyrą galite ištrinti čia: <a href="https://tenisouzsiemimai.lt/#/delete-account">https://tenisouzsiemimai.lt/#/delete-account</a>. Taip pat galite atšaukti kalendoriaus prieigą mobilioje programėlėje bet kuriuo metu.
        </Typography>
      </Paper>

      <Paper sx={{ p: 3, mb: 2 }}>
        <Typography variant="h6" gutterBottom fontWeight={600}>
          Slapukai ir technologijos
        </Typography>
        <Typography variant="body1" paragraph>
          Svetainė gali naudoti būtinus slapukus prisijungimui ir sesijoms. Naudojame „Google Analytics“ – galite apriboti slapukus per naršyklės nustatymus.
        </Typography>
      </Paper>

      <Paper sx={{ p: 3, mb: 2 }}>
        <Typography variant="h6" gutterBottom fontWeight={600}>
          Pakeitimai ir kontaktai
        </Typography>
        <Typography variant="body1" paragraph>
          Privatumo politikos pakeitimus skelbsime šiame puslapyje su atnaujinta data. Klausimams ar prašymams dėl duomenų rašykite mums el. paštu (nurodykite savo el. paštą arba naudokite kontaktus, pateiktus svetainėje TenisoUžsiėmimai.lt).
        </Typography>
      </Paper>

      <Box sx={{ mt: 4, pt: 2, borderTop: 1, borderColor: 'divider' }}>
        <Typography variant="body2" color="text.secondary">
          Naudodamiesi TenisoUžsiėmimai.lt svetaine ar mobilia programėle, sutinkate su šia privatumo politika.
        </Typography>
      </Box>
    </Container>
  );
};

export default PrivacyPolicyPage;
